var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthsaver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1357_14529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200C155.228 200 200 155.228 200 100Z",
    fill: "url(#paint0_linear_1357_14529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.016 105.135L59.0239 37V86.4733L100.016 105.135Z",
    stroke: "#FBFBFB",
    strokeWidth: 7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0238 36.9998L100.016 105.135L100.016 36.9998L59.0238 36.9998Z",
    stroke: "#FBFBFB",
    strokeWidth: 7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0239 129.413L100.016 105.137L59.0239 86.4751V129.413Z",
    stroke: "#FBFBFB",
    strokeWidth: 7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 129.396V163L100.015 105.135L59 129.396Z",
    stroke: "#FBFBFB",
    strokeWidth: 7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.001 37L100.016 105.135L141.001 86.4733V37Z",
    stroke: "#FBFBFB",
    strokeWidth: 7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.015 105.135L141 36.9998L100.015 36.9998L100.015 105.135Z",
    stroke: "#FBFBFB",
    strokeWidth: 7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.001 86.4751L100.016 105.137L141.001 129.413V86.4751Z",
    stroke: "#FBFBFB",
    strokeWidth: 7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.016 105.135L141.001 163V129.396L100.016 105.135Z",
    stroke: "#FBFBFB",
    strokeWidth: 7,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1357_14529",
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8034C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1357_14529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthsaver);
export default __webpack_public_path__ + "static/media/ethsaver.355b18f05970dca7a884ac1bf293990e.svg";
export { ForwardRef as ReactComponent };